export default __webpack_public_path__ + "static/media/digital-lines.92547a58.png";